<template>
    <component
        :is="isMobile ? 'q-slide-item' : 'div'"
        :class="{
            'is-expanded' : isExpanded,
            '-is-hidden' : project.assignmentsDateRange.count == 0 && project.assignmentsDateRange.countCanceled == 0,
        }"
        @click="toggleExpanded()"
        ref="js-slider"
        left-color="red" right-color="green"
        @left="onLeft" @right="onRight"
        @slide="sliding($event)"
        :data-component-name="$options.name"
    >
        <!-- <div class="c-notifications-checkbox">
            <q-checkbox dense size="24px" color="blue"
                :value="selected.includes(project.id)"
                @input="$emit('set-selected')"
            />
        </div> -->
        <template v-slot:left v-if="isMobile">
            <div class="slider-icon -all">
                <div class="column items-center">
                    <q-icon name="thumb_down" class="q-mb-sm" size="16px" />
                    <div>Refuser tout</div>
                    <small>({{ project.assignmentsDateRange.count+project.assignmentsDateRange.countCanceled }} affectations)</small>
                </div>
            </div>
        </template>
        <template v-slot:right v-if="isMobile">
            <div class="slider-icon -all">
                <div class="column items-center">
                    <q-icon name="thumb_up" class="q-mb-sm" size="16px" />
                    <div>Accepter tout</div>
                    <small>({{ project.assignmentsDateRange.count+project.assignmentsDateRange.countCanceled }} affectations)</small>
                </div>
            </div>
        </template>

        <div ref="js-content" class="c-notifications-content -data-header full-width">

            <div class="c-notifications-avatar">
                <!-- {{ project.id }} -->
                <UserAvatar 
                    :name="project.updated_by.name"
                    :email="project.updated_by.email"
                />
            </div>

            <div class="-from">
                <span class="-from-name">
                    <div class="o-row">
                        {{ project.updated_by.name }}
                        <div class="-date -hidden-desktop" v-html="getRelativeDate(project.updated_at)"></div>
                    </div>
                    <div class="-subject -hidden-desktop full-width">
                        {{ project.name }}
                        <ProjectCardToggle class="q-ml-sm" :myAssignments="true" :projectID="project.id" :size="'14px'" />
                    </div>
                    <div class="o-row -info -hidden-desktop">
                        du {{ date2str(project.assignmentsDateRange.from).long }}
                        au {{ date2str(project.assignmentsDateRange.to).long }}
                        <div class="-date -hidden-desktop">
                            <span class="-text-blue" v-if="project.assignmentsDateRange.count>0">
                                {{ project.assignmentsDateRange.count }} <q-icon name="assignment_ind"></q-icon>
                            </span>
                            <span v-if="project.assignmentsDateRange.countCanceled>0 && project.assignmentsDateRange.count>0">
                                 / 
                            </span>
                            <span class="-text-red" v-if="project.assignmentsDateRange.countCanceled>0">
                                {{ project.assignmentsDateRange.countCanceled }} <q-icon name="assignment_late"></q-icon>
                            </span>
                        </div>
                    </div>
                </span>
                <span class="-from-date -hidden-mobile"
                    v-html="getRelativeDate(project.updated_at)"
                >
                </span>
            </div>
            <div class="-name -hidden-mobile">
                {{ project.name }}
                <ProjectCardToggle class="q-ml-md" :myAssignments="true" :projectID="project.id" :size="'16px'" />
            </div>
            <div class="-period text-center -hidden-mobile">
                {{ date2str(project.assignmentsDateRange.from).short }}
                au {{ date2str(project.assignmentsDateRange.to).short }}
            </div>
            <div class="-assignmentsCount text-center -hidden-mobile">
                <div class="-text-blue" v-if="project.assignmentsDateRange.count>0">{{ project.assignmentsDateRange.count }} en attente</div>
                <div class="-text-red" v-if="project.assignmentsDateRange.countCanceled>0">{{ project.assignmentsDateRange.countCanceled }} annulée</div>
            </div>
            <div class="-date -hidden-mobile" v-html="getRelativeDate(project.updated_at)">
            </div>
        </div>
        <div class="c-notifications-content -body__wrapper full-widthwidth"
            @click="bodyClicked($event)"
        >
            <div class="-body" ref="body">
                <div class="-header -row -hidden-mobile">
                    <div class="-checkboxes">
                    </div>
                    <div class="-dates">
                        Dates d'affectations
                    </div>
                    <div class="-hours">
                        Heures
                    </div>
                    <div class="-shifts">
                        Quarts de travail
                    </div>
                    <div class="-professions">
                        Metier
                    </div>
                    <div class="-acceptation text-right">
                    </div>
                </div>

                <div class="-row -select-all -hidden-mobile">
                    <div class="-checkboxes text-right">
                        <q-checkbox dense 
                            v-model="selectAll" size="24px" color="blue"
                            :class="{'is-indeterminate': selectAll===null}"
                        />
                    </div>
                    <div class="flex-fill cursor-pointer"
                        @click="selectAll=!selectAll"
                    >
                        {{ this.selectAllLabel }}
                        <span v-if="userAssignments && userAssignments.data.length">
                            ({{ assignmentCount }} / {{ project.assignmentsDateRange.count}})
                        </span>
                    </div>
                    <div class="-acceptation">
                        <AcceptationSelect
                            ref="acceptSelected"
                            :userProfileID="userProfile.id"
                            :lastDenyReason="lastDenyReason"
                            :outline="false"
                            size="9px"
                            acceptButton="Accepter la sélection"
                            denyButton="Refuser la sélection"
                            :assignmentError="selectAll==false || loadingMore"
                            @accept-assignment="acceptAssignment($event, project, project.id)"
                        />
                    </div>
                </div>

                <div class="-assignments-list__wrap">
                    <div v-if="userAssignments && userAssignments.data.length>0"> 

                        <div class="-alternate"
                            v-if="!isMobile"
                        >
                            <PendingAssignment
                                class="-row -alternate"
                                :class="{
                                    '-is-accepting' : acceptedAssignments.includes(userAssignment.id)
                                }"
                                :key="userAssignment.id"
                                :ref="'assignment'+userAssignment.id"
                                v-for="(userAssignment) in userAssignments.data"
                                :assignment="userAssignment"
                                :project="project"
                                :selected="selected"
                                :acceptedAssignments="acceptedAssignments"
                                @set-selected="setSelected(userAssignment.id)"
                                @accept-assignment="acceptAssignment($event, project, project.id, userAssignment.id)"
                            />
                        </div>

                        <div class="-alternate" v-else>
                            <PendingAssignmentSlider
                                class="-row -alternate"
                                :class="{
                                    '-is-accepting' : acceptedAssignments.includes(userAssignment.id)
                                }"
                                :key="'r'+userAssignment.id"
                                :ref="'assignmentp'+userAssignment.id"
                                v-for="(userAssignment) in userAssignments.data"
                                :assignment="userAssignment"
                                :project="project"
                                :selected="selected"
                                :acceptedAssignments="acceptedAssignments"
                                @set-selected="setSelected(userAssignment.id)"
                                @accept-assignment="acceptAssignment($event, project, project.id, userAssignment.id)"
                            />
                        </div>

                    </div>

                </div>
                <div class="-row -load-more">
                    <div class="text-center full-width">
                        <span class="-load-more-button"
                            @click="loadMoreUserAssignments()"
                            v-if="!loading && userAssignments && userAssignments.paginatorInfo.hasMorePages"
                        >
                            <q-icon name="add" class="q-mr-xs" />
                            {{ project.assignmentsDateRange.count + project.assignmentsDateRange.countCanceled - userAssignments.data.length }}
                            <span
                                v-if="project.assignmentsDateRange.count + project.assignmentsDateRange.countCanceled - userAssignments.data.length > 1"
                            >affectations de plus</span>
                            <span
                                v-else
                            >affectation de plus</span>
                        </span>
                        <span v-if="!loadingMore && loading">
                            <q-spinner
                                color="primary"
                                class="q-mr-xs"
                            />
                            Chargement en cours
                        </span>
                    </div>
                </div>

                <!-- <div class="col-grow"></div>

                <div class="-info__wrap -hidden-mobile">
                    <div class="-info-item"
                        v-if="project.customers.length>0"
                    >
                        <div class="-label" v-if="project.customers.length==1">
                            Client
                        </div>
                        <div class="-label" v-if="project.customers.length>1">
                            Clients
                        </div>
                        <div v-html="'<div>' + project.customers.map(e => e.name).join('</div> <div>') +'</div>'">
                        </div>
                    </div>

                    <div class="-info-item"
                        v-if="project.projectManager"
                    >
                        <div class="-label">
                            Chargé de projet
                        </div>
                        <div v-html="project.projectManager.name">
                        </div>
                    </div>

                    <div class="-info-item"
                        v-if="project.contract_number"
                    >
                        <div class="-label">
                            No de contrat
                        </div>
                        <div v-html="project.contract_number">
                        </div>
                    </div>

                    <div class="-info-item"
                        v-if="project.supervisor"
                    >
                        <div class="-label">
                            Superviseur
                        </div>
                        <div v-html="project.supervisor.name">
                        </div>
                    </div>

                    <div class="-info-item"
                        v-if="project.description && project.description.trim()!=''"
                    >
                        <div class="-label">
                            Description
                        </div>
                        <div v-html="$nl2br(project.description)">
                        </div>
                    </div>

                    <div class="-info-item"
                        :key="cti"
                        v-for="(ct, cti) in groupCustomtags(project.customtags)"
                    >
                        <div class="-label">
                            {{ ct[0].label.name }}
                        </div>
                        <div v-html="'<div>' + ct.map(e => e.name).join('</> <div>') +'</div>'">
                        </div>
                    </div>

                    <div class="-info-item"
                        :key="cri"
                        v-for="(cr, cri) in groupResources(project.resources)"
                    >
                        <div class="-label">
                            {{ cr[0].label.name }}
                        </div>
                        <div v-html="'<div>' + cr.map(e => e.name).join('</> <div>') +'</div>'">
                        </div>
                    </div>
                </div> -->
            </div>
        </div>


        <!-- <PendingAssignment 
        /> -->
	</component>
</template>

<script>
    import { USERASSIGNMENTS } from "@/graphql/assignment/queries";
    import PendingAssignment from '@/components/notifications/PendingAssignment'
    import PendingAssignmentSlider from '@/components/notifications/PendingAssignmentSlider'
    import { ACCEPTNOTIFICATIONASSIGNMENT } from "@/graphql/notification/mutations"
    import { relativeDate } from "@/js/dateUtilities";
	import AcceptationSelect from "@/components/forms/AcceptationSelect"
	import { PROJECTSINBOX } from "@/graphql/notification/queries";
    import {date2str} from "@/js/dateUtilities"

    export default {
        name: 'PendingAssignments',
        components: {
            PendingAssignment,
            PendingAssignmentSlider,
            AcceptationSelect
        },
        props: {
            userProfile: {
                type: Object,
                default(){
                    return null
                }
            },
            project: {
                type: Object,
                default: null
            },
            index: {
                type: Number,
                default:0
            },
            isMobile: {
                type: Boolean,
                default: false
            }
        },
        data(){
        	return {
                pageSize: 15,
                isExpanded: false,
                selected: [],
                loading: false,
                skipQueriesStart: true,
                selectAll: false,
                selectAllLabel: 'Sélectionner tout',
                lastDenyReason: '',
                hiddenAssignments: [],
                acceptedAssignments: [],
                refetchTO: {},
                loadingMore: false,
        	}
        },
        mounted(){
        },
        computed: {
            assignmentCount: function(){
                if(!this.userAssignments) return 0;
                if(this.userAssignments.data.length>this.project.assignmentsDateRange.count) return this.project.assignmentsDateRange.count
                return this.userAssignments.data.length;
            }
        },
        watch: {
            isMobile: function(){
            },
            loadingMore: function(){
                if(!this.loadingMore) this.checkSelected();
            },
            selected: function(){
                this.selectAllLabel="Sélectionner tout";
                if(!this.userAssignments?.data) return this.selectAll=false;
                let unselected=this.userAssignments.data.filter(obj => !this.selected.includes(obj.id))
                if(unselected.length>0 && this.selected.length>0) return this.selectAll=null;
                if(this.userAssignments?.data.length==0 || this.selected.length==0) return this.selectAll=false;
                if(unselected.length==0){
                    this.selectAllLabel="Désélectionner tout";
                    return this.selectAll=true;
                } 
            },
            selectAll: function(){
                if(this.selectAll===false) this.selected=[];
                if(this.selectAll){
                    this.selected=[];
                    this.userAssignments.data.forEach(function(item){
                        this.selected.push(item.id)
                    }.bind(this))
                }
            },
        },
        methods: {
            setSelected(notificationID){
                if(this.selected.includes(notificationID)){
                    this.selected=this.selected.filter(obj => obj != notificationID)
                }else{
                    this.selected.push(notificationID)
                }
            },
            checkSelected(){
                if(!this.userAssignments) return;
                let assignmentsID = this.userAssignments.data.map(function(item) {return item["id"]});

                if(!assignmentsID) assignmentsID=[];
                let newSelected=[];
                // let newAccepting=[];

                this.selected.forEach(function(id){
                    if(assignmentsID.includes(id)) newSelected.push(id);
                })
                // this.acceptedAssignments.forEach(function(id){
                //     if(assignmentsID.includes(id)) newAccepting.push(id);
                // })

                this.selected=newSelected;
                // this.acceptedAssignments=newAccepting;
            },
            getRelativeDate(date){
                return relativeDate(date);
            },
            toggleExpanded(){
                if(this.isExpanded){
                    this.isExpanded=false;
                }else{                
                    this.isExpanded=true
                    if(this.$apollo.queries.userAssignments) this.$apollo.queries.userAssignments.refetch()
                    this.skipQueriesStart=false;

                    let scrollArea=this.$parent.$refs["js-notifications-list"]
                    if(scrollArea){
                        scrollArea.classList.remove('-snap-enable')
                        this.$scrollTo(this.$refs['js-content'], 500, {
                            container: scrollArea,
                            onDone: function(){
                                this.$nextTick(function(){
                                    scrollArea.classList.add('-snap-enable')
                                })
                            }.bind(this)
                        })
                    }
                }
            },
			groupCustomtags(customtags){
				let tmp=null;
				customtags.forEach(function(tag){
					let index=tag.customtag_label_id
					if(!tmp) tmp={};
					if(!tmp[index]) tmp[index]=[];
					tmp[index].push(tag);
				})
				let customtagsGroups=[];
				if(tmp) customtagsGroups=Object.values(tmp);
				return customtagsGroups;
			},
			groupResources(resources){
				let tmp=null;
				resources.forEach(function(resource){
					let index=resource.type.id
					if(!tmp) tmp={};
					if(!tmp[index]) tmp[index]=[];
					tmp[index].push(resource);
				})
				let resourcesGroups=[];
				if(tmp) resourcesGroups=Object.values(tmp);
				return resourcesGroups;
			},
            bodyClicked(e){
                e.stopPropagation();

                let emoji=false;
                e.path.forEach(element => {
                    if(element.id=="emoji-container"){
                        emoji=true;
                    }
                });
                if(!emoji && e.target.id!="emoji-popup" && !e.target.classList.contains("js-emojipicker")){
                    if(this.$refs.replyInput?.$refs.EmojiPicker?.$refs.picker?.isPickerOpen){
                        this.$refs.replyInput.$refs.EmojiPicker.$refs.picker.isPickerOpen=false;
                    }
                }
                
                if(e.target.classList.contains("o-button")){
                    e.stopPropagation();
                    this.$eventBus.$emit('jump-to-project', { projectID: e.target.dataset.projectid, currentDate: e.target.dataset.date})
                }
                if(e.target.classList.contains("c-notifications-data") && e.target.classList.contains("-collapsed")){
                    e.stopPropagation();
                    this.listenScroll=false;
                    e.target.classList.remove("-collapsed")
                    let conversationEl=this.$el.querySelectorAll(".js-conversation"+this.notification.id)
                    if(conversationEl){
                        conversationEl.forEach(function(el){
                            el.scrollTop=121000;
                        })
                    }    

                    clearTimeout(this.listenScrollTO);
                    this.listenScrollTO = setTimeout(function(){
                        this.listenScroll=true;
                    }.bind(this), 300)
                }
            },
            acceptAssignment(option, project, projectID=null, assignmentID=null){
                
                if(!this.isMobile) this.checkSelected();
                this.loadingMore=true;
				if(option.reason) this.lastDenyReason=option.reason;
                let assignmentIDs=this.selected;
                if(assignmentID){
                    assignmentIDs=[assignmentID];
                    this.acceptedAssignments.push(assignmentID);
                }

                this.$apollo.mutate({
                    mutation: ACCEPTNOTIFICATIONASSIGNMENT,
                    variables: {
                        assignmentID: assignmentIDs,
                        projectID: projectID,
                        userProfileID: this.userProfile.id,
                        action: option.value,
                        message: option.reason,
                        page: 1,
                        first: 1
                    }
				}).then(function(){
                    clearTimeout(this.refetchTO)

                    // if(!this.userAssignments) return this.refetchProject();

                    if(this.userAssignments?.paginatorInfo.hasMorePages){
                        this.refetchTO=setTimeout(function(){
                            this.refetchAllAssignments(this.userAssignments.data.length);
                            this.$eventBus.$emit('notifications-count', { projectID: this.projectID } )
                        }.bind(this), 400);
                    }else{
                        assignmentIDs.forEach(function(assignmentID){
                            this.userAssignments.data=this.userAssignments.data.filter(item => item.id!=assignmentID)
                        }.bind(this))

                        this.refetchTO=setTimeout(function(){
                            this.refetchProject()
                            this.$eventBus.$emit('notifications-count', { projectID: this.projectID } )
                        }.bind(this), 400);
                    }
				}.bind(this))

            },
            refetchAllAssignments(pageSize){
                this.$apollo.queries.userAssignments.fetchMore({
                    variables: {
                        page: 1,
                        first: pageSize,
                    },
                    watchLoading(){
                        this.loading=false;
                    },
                    updateQuery: (previousResult, { fetchMoreResult }) => {
                        this.refetchProject()
                        return {
                            userAssignments: {
                                __typename: previousResult.userAssignments.__typename,
                                data: fetchMoreResult.userAssignments.data,
                                paginatorInfo: fetchMoreResult.userAssignments.paginatorInfo,
                            }
                        }
                    }
                })
            },
            refetchProject(){
                this.$apollo.query({
                    query: PROJECTSINBOX,
                    fetchPolicy: 'network-only',
                    variables: { 
                        id: this.project.id,
                        userProfileID: this.userProfile.id,
                    }
                }).then(function(){
                    this.loadingMore=false;
                }.bind(this))
            },
            loadMoreUserAssignments(){
                this.$apollo.queries.userAssignments.fetchMore({
                    variables: {
                        page: Math.ceil((this.userAssignments.data.length+1)/this.pageSize),
                        first: this.pageSize,
                    },
                    updateQuery: (previousResult, { fetchMoreResult }) => {
                        return {
                            userAssignments: {
                                __typename: previousResult.userAssignments.__typename,
                                data: [...previousResult.userAssignments.data, ...fetchMoreResult.userAssignments.data],
                                paginatorInfo: fetchMoreResult.userAssignments.paginatorInfo,
                            }
                        }

                    }
                })
            },
            date2str(date){
                return date2str(date);
            },
            sliding(e){
                if(e.side=='left'){
                    this.$refs['js-slider'].$el.querySelector(".q-slide-item__left").style.opacity=e.ratio
                    let translateX=e.ratio*120;
                    this.$refs['js-slider'].$el.querySelector(".q-slide-item__content").style.transform='translateX('+translateX+'px)';
                }
                if(e.side=='right'){
                    this.$refs['js-slider'].$el.querySelector(".q-slide-item__right").style.opacity=e.ratio
                    let translateX=e.ratio*120;
                    this.$refs['js-slider'].$el.querySelector(".q-slide-item__content").style.transform='translateX(-'+translateX+'px)';
                }
            },
            onLeft({ reset }){
                this.reset=reset;
                this.prompt=true;
                return;
                // this.finalize(reset)
            },
            onRight(/*{ reset }*/){
                // this.$emit('accept-assignment', {value: 'accept', reason: ''})
                this.acceptAssignment({value: 'accept', reason: ''}, this.project, this.project.id)
                // this.finalize(reset)
            },
            finalize (reset) {
                this.timer = setTimeout(() => {
                    reset()
                }, 100)
            },
        },
        apollo: {
            userAssignments : {
                query: USERASSIGNMENTS,
                fetchPolicy: 'network-only',	//cache-first, cache-and-network, cache-only, network-only, no-cache -> https://v4.apollo.vuejs.org/guide-composable/query.html#fetch-policy
                //debounce: 200,
                error(error){
                    if (error.message) this.$q.notify({type: 'negative', message: 'Oh Oh', caption: error.message});
                },
                watchLoading(isLoading){
                    if(!this.loadingMore){
                        this.$emit('is-loading', isLoading)
                        this.loading=isLoading;
                    }
                },
                skip(){
                    return this.skipQueriesStart
                },
                variables() {
                    return {
                        userProfileID: this.userProfile.id,
                        projectID: this.project.id,
                        first: this.pageSize,
						pending: true,
                        page: 1
                    }
                },
                update(data) {
                    data.userAssignments.data=data.userAssignments.data.filter(item => !this.acceptedAssignments.includes(item.id))
                    return data.userAssignments
                },
            }
        }
    }
</script>

<style lang="scss">
    @import "@/scss/components/assignments/AssignmentsV2.scss";
</style>